import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal, ModalBody, ModalFooter, Spinner, Alert } from 'reactstrap';
import { deleteItem } from './redux/dispatcher';
import deleteImage from '../assets/img/delete.png'

//Delete model
function DeleteModel({ args, setIsDelete, id, apiEndpoint, flagName, setSearchQuery, setSelectedRoleType }) {
  const [modal, setModal] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const dispatch = useDispatch();
  const { deletedItemId } = useSelector((state) => state.deleteReducer);

  const toggle = () => {
    setModal(!modal);
    setIsDelete(false);
  };

  useEffect(() => {
    if (deletedItemId) {
      setSuccess(true);
      setLoading(false);
      setTimeout(() => {
        toggle();
      }, 2000);
    }
  }, [deletedItemId]);

  const handleDelete = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = { UUID: id }
      await dispatch(deleteItem({ data, apiEndpoint, flagName, setModal, setIsDelete, setSearchQuery, setSelectedRoleType }));
    } catch (err) {
      setError('Error occurred while deleting item.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Modal isOpen={modal} toggle={toggle} {...args}>
        <ModalBody>
          {error && <Alert color="danger">{error}</Alert>}
          {success && <Alert color="success">Item deleted successfully.</Alert>}
          {!error && !success && (
            <>
              <div className="text-center">
                <img src={deleteImage} alt="" style={{ width: '60px' }} />
                <p className="mt-3">Do you want to delete this record?</p>
              </div>
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <Button className="btn-primary" onClick={handleDelete} disabled={loading || success}>
            {loading ? <Spinner size="sm" /> : 'Delete'}
          </Button>{' '}
          <Button color="secondary" onClick={toggle} disabled={loading}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default DeleteModel;
